<script>
  export let heading = "Define Heading";
  export let name = "Define Name";
  export let value = 42;
  export let unit = "%";
  export let paxbot = false;
</script>

<div class="wrapper" class:paxbot={paxbot === true}>
  <div class="bold">{heading}</div>
  <div class="button_wrapper">
    {#if paxbot === false}
      <div class="container">
        <div class="small_kpi_name">{name}</div>
        <div class="small_kpi_value bold">{value}{unit}</div>
      </div>
    {/if}
  </div>
</div>

<style>
  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0.5rem;
    background-color: var(--pax-black);
    color: var(--pax-white);
    height: 4rem;
    align-items: center;
    padding: 0 1rem;
  }

  .paxbot {
    background-color: #ff5f1f;
  }

  .container {
    background-color: var(--pax-white);
    color: var(--pax-black);
    border-radius: 0.5rem;
    align-items: center;
    padding: 1rem;
    display: flex;
    gap: 0.5rem;
  }

  .button_wrapper {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
</style>
